import React from 'react'

type Props = {
  fieldProps: any
  displayText: string
  id?: string
  value: any
  disabled?: boolean
  comparisonValue?: any
}

export const AncientInputRadioJsonArray: React.FC<Props> = ({
  displayText,
  fieldProps,
  id,
  value,
  disabled,
  comparisonValue
}) => {
    const isPreviousSelection = displayText === comparisonValue;

    return (
    <div className='form-check form-check-custom form-check-solid form-check-sm mt-5 mb-5' key={id}>
      <input
        className='form-check-input'
        type='radio'
        checked={fieldProps.value === value}
        id={id}
        disabled={disabled}
        {...fieldProps}
        value={value}
      />
      <label className='form-check-label' htmlFor={id}>
        {displayText} {isPreviousSelection && <i> - Current Selection</i>}
      </label>
    </div>
  )
}
